import React, { useState } from 'react';

interface CodeSnippetProps {
  title: string;
  description: string;
  code?: string; // codeはオプショナル
}

export const CodeSnippet: React.FC<CodeSnippetProps> = ({ title, description, code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!code) return;

    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      // 2秒後にメッセージをリセット
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (!code) return null; // 表示するコードがなければ何も描画しない

  return (
    <div style={{ marginBottom: '2rem', border: '1px solid #ccc', padding: '1rem' }}>
      <h3>{title}</h3>
      <p>{description}</p>
      <div style={{ position: 'relative', backgroundColor: '#f5f5f5', padding: '1rem', paddingTop: '1.5rem' }}>
        <pre
          style={{
            whiteSpace: 'pre-wrap', // テキストを折り返す
            wordBreak: 'break-all', // 長い単語の途中でも改行する
            fontFamily: 'monospace' // 等幅フォントを指定
          }}
        >
          {code}
        </pre>
        <button onClick={handleCopy} style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '16px' }}>
          {copied ? 'コピーしました！' : 'コピー'}
        </button>
      </div>
    </div>
  );
};
